export enum LocationType {
  Region,
  Cinema,
}
